var map = {
	"./about-banner.png": "URkD",
	"./banner_img1.png": "FIs6",
	"./banner_img2.png": "pz1z",
	"./banner_img3.png": "8dFy",
	"./icon1.png": "HWEK",
	"./icon2.png": "HosE",
	"./icon3.png": "y9FJ",
	"./icon4.png": "K3X3",
	"./icon5.png": "7p1c",
	"./icon6.png": "OAQh",
	"./kh-0.png": "fExq",
	"./kh-1.png": "7Wpk",
	"./kh-10.png": "M28N",
	"./kh-11.png": "FSJ+",
	"./kh-12.png": "vJ6M",
	"./kh-13.png": "EHNc",
	"./kh-14.png": "PceH",
	"./kh-15.png": "D33n",
	"./kh-16.png": "C9fc",
	"./kh-17.png": "qOuJ",
	"./kh-18.png": "LeiN",
	"./kh-19.png": "wWTs",
	"./kh-2.png": "h4Ow",
	"./kh-20.png": "VWOO",
	"./kh-21.png": "St1A",
	"./kh-22.png": "WCKj",
	"./kh-23.png": "QkGh",
	"./kh-3.png": "mnjw",
	"./kh-4.png": "BNTQ",
	"./kh-5.png": "alKr",
	"./kh-6.png": "zFPc",
	"./kh-7.png": "CPzb",
	"./kh-8.png": "btgm",
	"./kh-9.png": "Qd+k",
	"./logo.png": "7Otq",
	"./service/cheliang.png": "tVbQ",
	"./service/diannao.png": "jOLk",
	"./service/fangwu.png": "pM/W",
	"./service/qipaotu.png": "ihde",
	"./service/shoutidai.png": "VBKf",
	"./service/shuju2x.png": "+88W",
	"./service/siyu.png": "7Fzp",
	"./service/tiyan.png": "yO7v",
	"./service/wenjianjia.png": "wdrA",
	"./service/xiangji.png": "C7cx",
	"./service/yingxiao.png": "M6CQ",
	"./service/zhuanhuan.png": "oqQA",
	"./slide_small0.png": "Nody",
	"./slide_small1.png": "p2lZ",
	"./slide_small2.png": "ojg0",
	"./slide_small3.png": "82mf",
	"./slide_small4.png": "411x",
	"./topbg.png": "DW8A"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 4